import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
  },
  mutations: {
    SET_LOGIN_STATE(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT(state) {
      state.isLoggedIn = false
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_LOGIN_STATE', true)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    checkLoginStatus({ commit, state }) {
      if (state.token) {
        commit('SET_LOGIN_STATE', true)
        return true
      } else {
        commit('SET_LOGIN_STATE', false)
        return false
      }
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    token: state => state.token,
    userInfo: state => state.userInfo
  }
})
